/**
 * Utility functions for demo mode handling
 */

/**
 * Returns the appropriate home path based on which demo user is logged in
 * @returns {string} The home path ("/demo1/home", "/guest/home", or "/home")
 */
export function getDemoHomePath() {
    if (localStorage.getItem("demo1_user")) {
        return "/demo1/home";
    }
    if (localStorage.getItem("demo_user")) {
        return "/guest/home";
    }
    return "/home";
}

/**
 * Checks if any demo user is currently logged in
 * @returns {boolean} True if a demo user is logged in
 */
export function isDemoUser() {
    return !!(localStorage.getItem("demo_user") || localStorage.getItem("demo1_user"));
}
